import {strTrim} from "@app/utils/CommonUtils";

export const standardEmails = (strEmails, char = ";") => {
    if (!strEmails) {
        return ""
    }
    let arrEmail = Array.isArray(strEmails) ? strEmails : strEmails.split(char)
    let outEmails = []
    arrEmail.forEach(item => {
        // STANDARD_GMAILS.forEach(s => {
        //     if (item.toLowerCase().indexOf("gmail.com") === -1 && item.toLowerCase().indexOf(s) > -1) {
        //         item = item.toLowerCase().replaceAll(s, "gmail.com")
        //     }
        // })
        let sEmail = item.toLowerCase()
        if (sEmail.indexOf("@gmail") > -1) {
            sEmail = sEmail.split("@gmail")[0] + "@gmail.com"
        }
        if (sEmail.indexOf("@yahoo") > -1) {
            sEmail = sEmail.split("@yahoo")[0] + "@yahoo.com"
        }
        // STANDARD_YAHOO_MAILS.forEach(s => {
        //     if (item.toLowerCase().indexOf("yahoo.com") === -1 && item.toLowerCase().indexOf(s) > -1) {
        //         item = item.toLowerCase().replaceAll(s, "yahoo.com")
        //     }
        // })
        if (!outEmails.includes(sEmail)) {
            outEmails.push(sEmail)
        }
    })

    return outEmails.join(char)
}

// emails is array
// standardPersonalEmails is array of personal emails dict.
export const validatePersonalEmails = (emails, standardPersonalEmails) => {
    for (let i=0; i < emails.length; i++) {
        const email = strTrim(emails[i]).toLowerCase()
        if (email) {
            let isValid = false
            for (let j=0; j < standardPersonalEmails.length; j++) {
                const spEmail = strTrim(standardPersonalEmails[j]).toLowerCase()
                if (spEmail) {
                    if (email.indexOf(spEmail) > -1) {
                        isValid = true
                        break
                    }
                }
            }

            if (!isValid) {
                return false
            }
        }

    }
    return true
}